var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLinkBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124 35.5H35.5C27.6761 35.5 20.1727 38.608 14.6403 44.1403C9.10803 49.6727 6 57.1761 6 65V212.5C6 220.324 9.10803 227.827 14.6403 233.36C20.1727 238.892 27.6761 242 35.5 242H183C190.824 242 198.327 238.892 203.86 233.36C209.392 227.827 212.5 220.324 212.5 212.5V124M109.25 138.75L242 6M242 6H168.25M242 6V79.75",
    stroke: "#4F6F8F",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkBig);
export default __webpack_public_path__ + "static/media/external_link_big.6d1841522ef2cc44802582079ff98b4e.svg";
export { ForwardRef as ReactComponent };